import { useLayoutEffect } from 'react';

function resetVysku(el) {
  if (!el) return;
  el.style.minHeight = '';
  el.style.height = '';
}

function dorovnajPar(lavy, pravy) {
  if (!lavy || !pravy) return;

  resetVysku(lavy);
  resetVysku(pravy);

  const rectLavy = lavy.getBoundingClientRect();
  const rectPravy = pravy.getBoundingClientRect();

  const cielovySpodok = Math.ceil(
    Math.max(rectLavy.top + rectLavy.height, rectPravy.top + rectPravy.height)
  );

  const novaVyskaLavy = Math.ceil(cielovySpodok - rectLavy.top);
  const novaVyskaPravy = Math.ceil(cielovySpodok - rectPravy.top);

  lavy.style.height = `${novaVyskaLavy}px`;
  pravy.style.height = `${novaVyskaPravy}px`;
}

export function useDorovnajKarty({
  psVstupRef,
  psVystupRef,
  invVstupRef,
  invVystupRef,
  ppOpen,
  invOpen,
  spustac,
}) {
  useLayoutEffect(() => {
    const karty = [
      psVstupRef?.current,
      psVystupRef?.current,
      invVstupRef?.current,
      invVystupRef?.current,
    ];

    const reset = () => {
      karty.forEach((el) => resetVysku(el));
    };

    let rafId = null;
    let naplanovane = false;

    const sync = () => {
    if (naplanovane) return;
    naplanovane = true;

    rafId = window.requestAnimationFrame(() => {
        naplanovane = false;

        reset();

        if (window.innerWidth < 981) return;

        if (ppOpen) {
        dorovnajPar(psVstupRef?.current, psVystupRef?.current);
        }

        if (invOpen) {
        dorovnajPar(invVstupRef?.current, invVystupRef?.current);
        }
    });
    };

    sync();

    let observer = null;

    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(() => {
        sync();
      });

      karty.forEach((el) => {
        if (el) observer.observe(el);
      });
    }

    window.addEventListener('resize', sync);

    return () => {
      window.removeEventListener('resize', sync);
      if (observer) observer.disconnect();
      if (rafId) cancelAnimationFrame(rafId);
      naplanovane = false;
      reset();
    };
  }, [
    psVstupRef,
    psVystupRef,
    invVstupRef,
    invVystupRef,
    ppOpen,
    invOpen,
    spustac,
  ]);
}